/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import store from "../../store";
import PremiumPricing from "./PremiumPricing";

const ProviderComponent: FunctionComponent<unknown> = () => (
  <Provider store={store}>
    <PremiumPricing />
  </Provider>
);

export default ProviderComponent;
